// plugins/createHrPlugin.tsx
import React from 'react';
import { CellPlugin } from '@react-page/editor';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';

export function createHrPlugin(): CellPlugin<Record<string, unknown>> {
  return {
    id: 'hr',
    title: 'Horizontal Rule',
    description: 'Insert a full‑width separator',
    icon: <HorizontalRuleIcon />,   // toolbar icon
    version: 1,

    // Rendered in both edit and read‑only mode
    Renderer: () => <hr />,
    // ← no `controls` field; React‑Page shows it as a “click‑to‑select”
  };
}
